export const IconCelebratingUser = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M15.86 3.54C15.418 5.28 13.825 6.5 12 6.5S8.583 5.28 8.14 3.54l-.384-1.5c-.184-.735-.945-1.182-1.698-.997A1.37 1.37 0 0 0 5.043 2.71l.38 1.5A6.67 6.67 0 0 0 8.85 8.49v13.135c0 .76.625 1.375 1.4 1.375s1.4-.614 1.4-1.375v-5.5h.7v5.5c0 .76.626 1.375 1.4 1.375.775 0 1.4-.614 1.4-1.375V8.489a6.67 6.67 0 0 0 3.427-4.28l.38-1.499a1.373 1.373 0 0 0-1.019-1.667c-.753-.185-1.51.262-1.693.997l-.381 1.5zM12 5.124a2.12 2.12 0 0 0 1.485-.604c.394-.387.616-.911.616-1.458 0-.548-.222-1.072-.616-1.459A2.12 2.12 0 0 0 12 1a2.12 2.12 0 0 0-1.485.604A2.04 2.04 0 0 0 9.9 3.063c0 .547.221 1.071.615 1.458A2.12 2.12 0 0 0 12 5.125" />
    </svg>
  );
};
